/**
 * focusWithoutScroll
 *
 * Programmatischer Fokus **ohne** den Browser-Autoscroll. `HTMLElement.focus()` scrollt das Element
 * per Default in den sichtbaren Bereich – und zwar den nächsten Scroll-Container **und** das
 * Fenster. In der Notenvorschau sitzen die Eingabefelder (Gesangstext-, Bass-Popover) im
 * `overflow-auto`-Scroller über der Partitur; jedes Fokussieren riss die Seite dorthin. Besonders
 * auffällig beim Gesangstext: dort wird nach **jeder** Silbe neu fokussiert
 * (`watch(selectedNote)` → `focusInput()`).
 *
 * Konvention (siehe webapp/src/VUE_RULES.md): programmatischer Fokus läuft ausschließlich über diesen
 * Helfer – nie `el.focus()` ohne `{preventScroll: true}`. Abgesichert durch
 * `webapp/src/__tests__/noAutoScroll.spec.ts`.
 */
export function focusWithoutScroll(el: HTMLElement | null | undefined): void {
    el?.focus({preventScroll: true});
}
